import { messages } from "../i18n/index.ts";
import { Sheet } from "./Sheet.tsx";

interface SupportSheetProps {
  open: boolean;
  href: string;
  onClose: () => void;
}

export function SupportSheet({ open, href, onClose }: SupportSheetProps) {
  return (
    <Sheet
      open={open}
      title={messages.support.title}
      accent="flame"
      placement="center"
      onClose={onClose}
    >
      <div className="support-copy">
        <span className="support-copy__heart" aria-hidden="true">♥</span>
        <p>{messages.support.description}</p>
        <p className="support-copy__notice">{messages.support.noBenefits}</p>
        <p className="text-xs text-muted">{messages.support.externalNotice}</p>
      </div>
      <div className="mt-6 flex gap-2">
        <button type="button" className="btn-secondary" onClick={onClose}>
          {messages.support.notNow}
        </button>
        <a
          className="btn-primary btn-primary--flame support-link"
          href={href}
          target="_blank"
          rel="noopener noreferrer"
        >
          {messages.support.openKreosus}
        </a>
      </div>
    </Sheet>
  );
}
